import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path fill="#FBE9B1" d="M16 23.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15" />
    <path
      fill="#E2BA2B"
      d="M16 1a1 1 0 0 1 1 1v2.5a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1"
    />
    <path
      fill="#E2BA2B"
      fillRule="evenodd"
      d="M16 7.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 2a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13"
      clipRule="evenodd"
    />
    <path
      fill="#E2BA2B"
      d="M6.807 5.393a1 1 0 1 0-1.414 1.414l1.762 1.762a1 1 0 1 0 1.414-1.414zM4.5 15a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2zM8.57 23.43a1 1 0 0 0-1.415 0l-1.762 1.763a1 1 0 1 0 1.414 1.414l1.762-1.762a1 1 0 0 0 0-1.414M16 26.5a1 1 0 0 1 1 1V30a1 1 0 1 1-2 0v-2.5a1 1 0 0 1 1-1M24.845 23.43a1 1 0 0 0-1.414 1.415l1.762 1.762a1 1 0 1 0 1.414-1.414zM30 15a1 1 0 1 1 0 2h-2.5a1 1 0 1 1 0-2zM26.607 5.393a1 1 0 0 0-1.414 0L23.43 7.155a1 1 0 0 0 1.414 1.414l1.762-1.762a1 1 0 0 0 0-1.414"
    />
  </svg>
);
const SvgIconWeatherSun = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherSun);
export default Memo;
